{
  "settings": "Ustawienia",
  "yourDigitalAssistant": "Twój wirtualny asystent",
  "getStarted": "Rozpocznij",
  "login": "Zaloguj sie",
  "loggingIn": "Logowanie ...",
  "darkMode": "Tryb ciemny",
  "clearHistory": "Wyczyść historię",
  "historyCleared": "Historia wyczyszczona",
  "changeLanguage": "Język",
  "termsAndConditions": "Regulamin",
  "messagePlaceholder": "Wpisz tutaj swoją wiadomość ...",
  "messagePlaceholderDisabled": "Pisanie wyłączone ...",
  "feedbackTitle": "Oceń swoje wrażenia",
  "feedbackPlaceholder": "Powiedz nam o tym (opcjonalnie)",
  "feedbackSend": "Wyślij",
  "feedbackClose": "Zamknąć",
  "sessionExpired": "Twoja sesja wygasła z powodu braku aktywności.",
  "startNewSession": "Rozpocznij nową sesję",
  "apiError": "Ups! Coś poszło nie tak. Pracujemy nad jak najszybszym naprawieniem tego problemu.",
  "apiErrorOffline": "Nie masz połączenia z Internetem.",
  "tryAgain": "Spróbuj ponownie",
  "startOver": "Zacznij od nowa",
  "chatEnded": "Czat zakończył się.",
  "chatEndedThankYou": "Dziękujemy za rozmowę!",
  "closeChat": "Zamknąć",
  "startNewChat": "Porozmawiaj ponownie",
  "humanTakeoverStarted": "Przeniesiono Cię do działu obsługi klienta ...",
  "humanTakeoverQueued": "Oczekiwanie na połączenie z agentem",
  "humanTakeoverAnAgent": "Agent",
  "humanTakeoverAgentEntered": "wszedł do rozmowy",
  "humanTakeoverAgentLogout": "opuścić konwersację",
  "humanTakeoverTransfer": "Zostaniesz przeniesiony do nowego agenta",
  "humanTakeoverEnded": "Rozmawiasz teraz ze swoim wirtualnym asystentem",
  "version": "Wersja",
  "formIntroText": "Wypełnij poniższy formularz, aby rozpocząć z nami rozmowę.",
  "formFirstName": "Imię",
  "formLastName": "Nazwisko",
  "formName": "Nazwa",
  "formEmail": "E-mail",
  "formWrongEmail": "Podaj prawidłowy adres e-mail.",
  "formPhone": "Telefon",
  "formShipmentId": "ID przesyłki",
  "formQuestion": "Twoje pytanie",
  "formAccountNumber": "Numer konta (dla klientów biznesowych)",
  "formAddress": "Adres",
  "formPostcode": "Kod pocztowy",
  "formCity": "Miasto",
  "formCountry": "Kraj",
  "formSubmitButton": "Rozpocznij czat",
  "formEmptyFieldError": "Nie wolno być pustym.",
  "formPhoneNumberValidationError": "Nieprawidłowy numer telefonu.",
  "formInputIsBiggerThan50": "Musi mieć maksymalnie 50 znaków.",
  "formInputIsBiggerThan100": "Musi mieć maksymalnie 100 znaków.",
  "formInputIsBiggerThan2000": "Musi mieć maksymalnie 2000 znaków.",
  "widgetEventOnline": "Wiadomość DA: Użytkownik jest ponownie online.",
  "widgetEventHidden": "Wiadomość DA: Widżet jest ukryty.",
  "widgetEventVisible": "Wiadomość DA: Widżet jest widoczny.",
  "widgetEventVisibleMinimized": "Wiadomość DA: Widżet jest widoczny, ale zminimalizowany.",
  "widgetEventMinimized": "Wiadomość DA: Widżet jest zminimalizowany.",
  "widgetEventMaximized": "Wiadomość DA: Widżet jest zmaksymalizowany.",
  "widgetEventSessionExpired": "Wiadomość DA: sesja widżetu wygasła.",
  "widgetEventHangupHuman": "Komunikat DA: Użytkownik kończy sesję przejęcia przez człowieka.",
  "widgetEventUserTyping": "Wiadomość DA: użytkownik pisze.",
  "fileTooLarge": "Próbujesz dołączyć zbyt duże pliki.",
  "tooManyDiles": "Próbujesz dołączyć zbyt wiele plików.",
  "fileInvalidType": "Próbujesz dołączyć nieprawidłowe typy plików.",
  "attachmentsDropHere": "Upuść tutaj, aby przesłać lub",
  "attachmentsBrowse": "Przeglądaj pliki",
  "attachmentsExtenstionQuantity": "pdf lub obrazy (do 10 plików)",
  "attachmentsSize": "do 30 MB",
  "attachmentsFailedUploading": "Przesyłanie nie powiodło się",
  "attachmentsUploading": "Przesyłanie ...",
  "minimizeExpandText": "Porozmawiaj z nami na żywo!",
  "popupWidgetNotificationMessage": "Otrzymałeś nową wiadomość!",
  "tabWidgetNotificationMessage": "Nowa wiadomość!",
  "datepickerSendButton": "Wysłać"
}
